import React, { ButtonHTMLAttributes, type FC } from 'react'
import { ButtonWithIconStyled } from './Buttons.styles'

type Props = Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & {
  icon: JSX.Element
  color?: 'dark' | 'light'
  isDisabled?: boolean
}

export const ButtonWithIcon: FC<Props> = ({ onClick, icon, color = 'dark', isDisabled }) => (
  <ButtonWithIconStyled onClick={onClick} color={color} disabled={isDisabled}>
    {icon}
  </ButtonWithIconStyled>
)
